<div class="options-library-set-card" [class.checked]="checked()">
  <mat-checkbox color="primary" [checked]="checked()" (change)="selected.emit($event)"></mat-checkbox>

  <div class="options-library-set-card__content">
    <div class="options-library-set-card__content__text">
      <h2 class="options-library-set-card__content__text-title">{{ optionSet().name }}</h2>
      @if (optionSet().description) {
        <span class="options-library-set-card__content__text-subtitle">{{ optionSet().description }}</span>
      }
    </div>

    <div>
      <h2 class="fs__sm fw__600">Options ({{ optionSet().options.length }})</h2>
      <ol class="options-library-set-card__content__options">
        @for (option of optionsFiltered(); track option.id) {
          <li class="fs__sm fw__500">{{ option.text }}</li>
        }
      </ol>

      @if (expanded$()) {
        <span class="options-library-set-card__content__expand fs__sm fw__500" (click)="expanded$.set(false)">Hide <fa-icon [icon]="faChevronUp"></fa-icon></span>
      } @else if (optionSet().options.length - optionsFiltered().length > 0) {
        <span class="options-library-set-card__content__expand fs__sm fw__500" (click)="expanded$.set(true)">
          ... and {{ optionSet().options.length - optionsFiltered().length }} more options
          <fa-icon [icon]="faChevronDown"></fa-icon>
        </span>
      }
    </div>
  </div>

  <div class="options-library-set-card__subfix">
    <button mat-icon-button title="Export to" color="light" [matMenuTriggerFor]="menu">
      <fa-icon [icon]="faEllipsisVertical"></fa-icon>
    </button>

    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="duplicate.emit()">
        <span>Duplicate options</span>
      </button>
      <button mat-menu-item (click)="edit.emit()">
        <span>Edit</span>
      </button>
      <button mat-menu-item (click)="delete.emit()">
        <span>Delete</span>
      </button>
    </mat-menu>
  </div>
</div>
